// common: the words of these screens in both languages. Each table is the
// one its component defined; moved here verbatim so a domain reads as one
// vocabulary and a translation is corrected in one place.
import { WOLOF, withWolof } from "./wolof";

// components/CheckoutProgress.jsx
export const checkoutProgressL = {
  en: { travelers: "Travelers", payment: "Payment", confirmed: "Confirmed", step: "Step", of: "of", next: "Next", done: "All done", car: { offer: "Your deal", protection: "Protection", driver: "Driver", label: "Booking steps" } },
  fr: { travelers: "Voyageurs", payment: "Paiement", confirmed: "Confirmé", step: "Étape", of: "sur", next: "Suivant", done: "Terminé", car: { offer: "Votre offre", protection: "Protection", driver: "Conducteur", label: "Étapes de la réservation" } },
  es: { travelers: "Viajeros", payment: "Pago", confirmed: "Confirmado", step: "Paso", of: "de", next: "Siguiente", done: "Todo listo", car: { offer: "Tu oferta", protection: "Protección", driver: "Conductor", label: "Pasos de la reserva" } },
  pt: { travelers: "Viajantes", payment: "Pagamento", confirmed: "Confirmado", step: "Etapa", of: "de", next: "Seguinte", done: "Concluído", car: { offer: "A sua oferta", protection: "Proteção", driver: "Condutor", label: "Etapas da reserva" } },
  ar: { travelers: "المسافرون", payment: "الدفع", confirmed: "تم التأكيد", step: "الخطوة", of: "من", next: "التالي", done: "اكتمل كل شيء", car: { offer: "عرضك", protection: "الحماية", driver: "السائق", label: "خطوات الحجز" } },
  zh: { travelers: "旅客", payment: "付款", confirmed: "已确认", step: "第", of: "步，共", next: "下一步", done: "全部完成", car: { offer: "您的报价", protection: "保障", driver: "驾驶人", label: "预订步骤" } },
};

// components/GuestContactModal.jsx
export const guestContactModalL = {
  en: {
    title: "Your contact details",
    sub: "We'll send your Toukky booking number to this email. No account needed.",
    name: "Full name", email: "Email address", phone: "Phone",
    cancel: "Cancel", wait: "Please wait…", go: "Continue to payment",
    already: "Already have an account? You can sign in after your booking is confirmed.",
    errName: "Please enter your full name",
    errEmail: "Please enter a valid email",
    errPhone: "Please enter a valid phone number",
  },
  fr: {
    title: "Vos coordonnées",
    sub: "Nous enverrons votre numéro de réservation Toukky à cette adresse. Aucun compte nécessaire.",
    name: "Nom complet", email: "Adresse e-mail", phone: "Téléphone",
    cancel: "Annuler", wait: "Veuillez patienter…", go: "Passer au paiement",
    already: "Vous avez déjà un compte ? Vous pourrez vous connecter une fois la réservation confirmée.",
    errName: "Veuillez saisir votre nom complet",
    errEmail: "Veuillez saisir une adresse e-mail valide",
    errPhone: "Veuillez saisir un numéro de téléphone valide",
  },
  es: {
    title: "Tus datos de contacto",
    sub: "Enviaremos tu número de reserva Toukky a este correo. No necesitas cuenta.",
    name: "Nombre completo", email: "Correo electrónico", phone: "Teléfono",
    cancel: "Cancelar", wait: "Un momento…", go: "Continuar al pago",
    already: "¿Ya tienes una cuenta? Podrás iniciar sesión una vez confirmada tu reserva.",
    errName: "Introduce tu nombre completo",
    errEmail: "Introduce un correo electrónico válido",
    errPhone: "Introduce un número de teléfono válido",
  },
  pt: {
    title: "Os seus dados de contacto",
    sub: "Enviaremos o seu número de reserva Toukky para este e-mail. Não precisa de conta.",
    name: "Nome completo", email: "Endereço de e-mail", phone: "Telefone",
    cancel: "Cancelar", wait: "Aguarde…", go: "Continuar para o pagamento",
    already: "Já tem uma conta? Poderá iniciar sessão depois de a reserva ser confirmada.",
    errName: "Indique o seu nome completo",
    errEmail: "Indique um e-mail válido",
    errPhone: "Indique um número de telefone válido",
  },
  ar: {
    title: "بيانات الاتصال الخاصة بك",
    sub: "سنرسل رقم حجزك في Toukky إلى هذا البريد الإلكتروني. لا حاجة لإنشاء حساب.",
    name: "الاسم الكامل", email: "البريد الإلكتروني", phone: "الهاتف",
    cancel: "إلغاء", wait: "يرجى الانتظار…", go: "المتابعة إلى الدفع",
    already: "هل لديك حساب بالفعل؟ يمكنك تسجيل الدخول بعد تأكيد حجزك.",
    errName: "يرجى إدخال اسمك الكامل",
    errEmail: "يرجى إدخال بريد إلكتروني صالح",
    errPhone: "يرجى إدخال رقم هاتف صالح",
  },
  zh: {
    title: "您的联系方式",
    sub: "我们会将您的 Toukky 预订编号发送到此邮箱。无需注册账户。",
    name: "全名", email: "电子邮箱", phone: "电话",
    cancel: "取消", wait: "请稍候…", go: "继续付款",
    already: "已有账户？预订确认后即可登录。",
    errName: "请输入您的全名",
    errEmail: "请输入有效的电子邮箱",
    errPhone: "请输入有效的电话号码",
  },
};

// components/PreSearchState.jsx
export const preSearchStateL = {
  en: {
    flights: {
      title: "Where would you like to fly?",
      subtitle: "Enter your origin, destination and travel date above, then press Search flights to see live offers.",
    },
    hotels: {
      title: "Where would you like to stay?",
      subtitle: "Enter your destination and dates above, then press Search to see available properties.",
    },
    cars: {
      title: "Where would you like to drive?",
      subtitle: "Pick a city and dates above, then press Search to see available vehicles.",
    },
    hint: "Choose your destination and dates to start your search.",
    trust: [
      ["Review your options", "Check the details before you book."],
      ["Find your next trip", "Choose where and when you want to go."],
      ["Keep track of your trip", "Access your details in Manage booking."],
    ],
  },
  fr: {
    flights: {
      title: "Quelle est votre prochaine destination ?",
      subtitle: "Indiquez les aéroports de départ et d’arrivée ainsi que vos dates, puis sélectionnez Rechercher un vol.",
    },
    hotels: {
      title: "Où souhaitez-vous séjourner ?",
      subtitle: "Indiquez votre destination et vos dates ci-dessus, puis lancez la recherche pour voir les logements disponibles.",
    },
    cars: {
      title: "Où souhaitez-vous conduire ?",
      subtitle: "Choisissez une ville et des dates ci-dessus, puis lancez la recherche pour voir les véhicules disponibles.",
    },
    hint: "Choisissez votre destination et vos dates pour lancer la recherche.",
    trust: [
      ["Comparez vos options", "Vérifiez les détails avant de réserver."],
      ["Trouvez votre prochain voyage", "Choisissez où et quand vous voulez partir."],
      ["Suivez votre voyage", "Retrouvez vos informations dans Gérer ma réservation."],
    ],
  },
  es: {
    flights: {
      title: "¿Adónde te gustaría volar?",
      subtitle: "Indica arriba tu origen, destino y fecha de viaje, luego pulsa Buscar vuelos para ver las ofertas en directo.",
    },
    hotels: {
      title: "¿Dónde te gustaría alojarte?",
      subtitle: "Indica arriba tu destino y tus fechas, luego pulsa Buscar para ver los alojamientos disponibles.",
    },
    cars: {
      title: "¿Adónde te gustaría conducir?",
      subtitle: "Elige arriba una ciudad y las fechas, luego pulsa Buscar para ver los vehículos disponibles.",
    },
    hint: "Elija destino y fechas para iniciar la búsqueda.",
    trust: [
      ["Revisa tus opciones", "Comprueba los detalles antes de reservar."],
      ["Encuentra tu próximo viaje", "Elige adónde y cuándo quieres ir."],
      ["Sigue tu viaje", "Consulta tus datos en Gestionar reserva."],
    ],
  },
  pt: {
    flights: {
      title: "Para onde gostaria de voar?",
      subtitle: "Indique acima a origem, o destino e a data da viagem e depois prima Pesquisar voos para ver as ofertas em tempo real.",
    },
    hotels: {
      title: "Onde gostaria de ficar?",
      subtitle: "Indique acima o destino e as datas e depois prima Pesquisar para ver os alojamentos disponíveis.",
    },
    cars: {
      title: "Para onde gostaria de conduzir?",
      subtitle: "Escolha acima uma cidade e as datas e depois prima Pesquisar para ver os veículos disponíveis.",
    },
    hint: "Escolha o destino e as datas para iniciar a pesquisa.",
    trust: [
      ["Analise as suas opções", "Verifique os detalhes antes de reservar."],
      ["Encontre a sua próxima viagem", "Escolha para onde e quando quer ir."],
      ["Acompanhe a sua viagem", "Aceda aos seus dados em Gerir reserva."],
    ],
  },
  ar: {
    flights: {
      title: "إلى أين تود السفر؟",
      subtitle: "أدخل نقطة الانطلاق والوجهة وتاريخ السفر أعلاه، ثم اضغط على بحث عن رحلات لعرض العروض المتاحة.",
    },
    hotels: {
      title: "أين تود الإقامة؟",
      subtitle: "أدخل وجهتك وتواريخك أعلاه، ثم اضغط على بحث لعرض أماكن الإقامة المتاحة.",
    },
    cars: {
      title: "أين تود القيادة؟",
      subtitle: "اختر مدينة وتواريخ أعلاه، ثم اضغط على بحث لعرض السيارات المتاحة.",
    },
    hint: "اختر وجهتك وتواريخك لبدء البحث.",
    trust: [
      ["راجع خياراتك", "تحقق من التفاصيل قبل الحجز."],
      ["اعثر على رحلتك القادمة", "اختر إلى أين ومتى تريد الذهاب."],
      ["تابع رحلتك", "اطّلع على بياناتك في إدارة الحجز."],
    ],
  },
  zh: {
    flights: {
      title: "您想飞往哪里？",
      subtitle: "在上方输入出发地、目的地和出行日期，然后点击搜索航班查看实时报价。",
    },
    hotels: {
      title: "您想住在哪里？",
      subtitle: "在上方输入目的地和日期，然后点击搜索查看可预订的住宿。",
    },
    cars: {
      title: "您想去哪里自驾？",
      subtitle: "在上方选择城市和日期，然后点击搜索查看可租车辆。",
    },
    hint: "选择目的地和日期，开始搜索。",
    trust: [
      ["查看您的选择", "预订前请核对详情。"],
      ["找到您的下一次旅行", "选择您想去的地方和时间。"],
      ["随时掌握行程", "在“管理预订”中查看您的信息。"],
    ],
  },
};

// components/layout/SkipLink.jsx
export const skipLinkL = {
  en: { label: "Skip to content" },
  fr: { label: "Aller au contenu" },
  es: { label: "Ir al contenido" },
  pt: { label: "Ir para o conteúdo" },
  ar: { label: "الانتقال إلى المحتوى" },
  zh: { label: "跳至内容" },
};

// components/layout/Footer.jsx
export const footerL = {
  en: {
    support: "Support", contact: "Contact us", manage: "Manage booking", faq: "FAQ",
    cancel: "Cancel booking", refund: "Refund policy",
    explore: "Explore", flights: "Flights", stays: "Stays", flightHotel: "Flight + Hotel",
    cars: "Cars", attractions: "Attractions",
    company: "Company", about: "About Toukky", partners: "Become a partner",
    legal: "Legal", terms: "Terms & conditions", privacy: "Privacy policy",
    cookies: "Cookie preferences",
    tagline: "Search flights, hotels and travel deals around the world.",
    rights: "© 2026 Toukky Travel LLC. All rights reserved.",
    language: "English",
  },
  fr: {
    support: "Assistance", contact: "Nous contacter", manage: "Gérer ma réservation", faq: "Questions fréquentes",
    cancel: "Annuler une réservation", refund: "Politique de remboursement",
    explore: "Explorer", flights: "Vols", stays: "Séjours", flightHotel: "Vol + Hôtel",
    cars: "Voitures", attractions: "Activités",
    company: "Entreprise", about: "À propos de Toukky", partners: "Devenir partenaire",
    legal: "Mentions légales", terms: "Conditions générales", privacy: "Politique de confidentialité",
    cookies: "Préférences de cookies",
    tagline: "Cherchez des vols, hôtels et offres de voyage partout dans le monde.",
    rights: "© 2026 Toukky Travel LLC. Tous droits réservés.",
    language: "Français",
  },
  es: {
    support: "Ayuda", contact: "Contáctanos", manage: "Gestionar reserva", faq: "Preguntas frecuentes",
    cancel: "Cancelar reserva", refund: "Política de reembolso",
    explore: "Explorar", flights: "Vuelos", stays: "Alojamientos", flightHotel: "Vuelo + Hotel",
    cars: "Coches", attractions: "Actividades",
    company: "Empresa", about: "Sobre Toukky", partners: "Hazte partner",
    legal: "Legal", terms: "Términos y condiciones", privacy: "Política de privacidad",
    cookies: "Preferencias de cookies",
    tagline: "Busca vuelos, hoteles y ofertas de viaje en todo el mundo.",
    rights: "© 2026 Toukky Travel LLC. Todos los derechos reservados.",
    language: "Español",
  },
  pt: {
    support: "Apoio", contact: "Contacte-nos", manage: "Gerir reserva", faq: "Perguntas frequentes",
    cancel: "Cancelar reserva", refund: "Política de reembolso",
    explore: "Explorar", flights: "Voos", stays: "Estadias", flightHotel: "Voo + Hotel",
    cars: "Carros", attractions: "Atividades",
    company: "Empresa", about: "Sobre a Toukky", partners: "Torne-se parceiro",
    legal: "Legal", terms: "Termos e condições", privacy: "Política de privacidade",
    cookies: "Preferências de cookies",
    tagline: "Pesquise voos, hotéis e ofertas de viagem em todo o mundo.",
    rights: "© 2026 Toukky Travel LLC. Todos os direitos reservados.",
    language: "Português",
  },
  ar: {
    support: "الدعم", contact: "اتصل بنا", manage: "إدارة الحجز", faq: "الأسئلة الشائعة",
    cancel: "إلغاء الحجز", refund: "سياسة الاسترداد",
    explore: "استكشف", flights: "الرحلات الجوية", stays: "الإقامات", flightHotel: "طيران + فندق",
    cars: "السيارات", attractions: "الأنشطة",
    company: "الشركة", about: "عن Toukky", partners: "كن شريكاً",
    legal: "قانوني", terms: "الشروط والأحكام", privacy: "سياسة الخصوصية",
    cookies: "تفضيلات ملفات تعريف الارتباط",
    tagline: "ابحث عن رحلات جوية وفنادق وعروض سفر حول العالم.",
    rights: "© 2026 Toukky Travel LLC. جميع الحقوق محفوظة.",
    language: "العربية",
  },
  zh: {
    support: "帮助", contact: "联系我们", manage: "管理预订", faq: "常见问题",
    cancel: "取消预订", refund: "退款政策",
    explore: "探索", flights: "机票", stays: "住宿", flightHotel: "机票 + 酒店",
    cars: "租车", attractions: "活动",
    company: "公司", about: "关于 Toukky", partners: "成为合作伙伴",
    legal: "法律信息", terms: "条款与条件", privacy: "隐私政策",
    cookies: "Cookie 偏好设置",
    tagline: "搜索全球机票、酒店和旅行优惠。",
    rights: "© 2026 Toukky Travel LLC. 保留所有权利。",
    language: "简体中文",
  },
};

// components/layout/RouteTitle.jsx
export const pageTitlesL = {
  en: {
    home: "Toukky — Where do you want to go?",
    exact: {
      "/": "", "/hotels": "Stays", "/flights": "Flights", "/flight-hotel": "Flight + Hotel", "/cars": "Car hire",
      "/attractions": "Activities", "/airport-taxis": "Airport taxis", "/login": "Sign in", "/signup": "Create an account",
      "/forgot-password": "Forgot password", "/reset-password": "New password", "/account": "My account",
      "/bookings": "My bookings", "/manage": "Manage booking", "/support": "Support", "/support/cases": "My support requests",
      "/about": "About Toukky", "/faq": "Help & FAQ", "/refund-policy": "Refund policy", "/terms": "Terms & conditions",
      "/privacy": "Privacy policy", "/cookies": "Cookie preferences", "/partners": "Partners", "/partners/register": "Become a partner", "/partners/register/payouts": "Payouts", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "Stay", flightDetail: "Flight", passengers: "Passengers", carDetail: "Car",
    bookingDetail: "Booking", bookingSuccess: "Booking status", partnerArea: "Partner area", supportCase: "Support request",
  },
  fr: {
    home: "Toukky — Où voulez-vous aller ?",
    exact: {
      "/": "", "/hotels": "Séjours", "/flights": "Vols", "/flight-hotel": "Vol + Hôtel", "/cars": "Location de voitures",
      "/attractions": "Activités", "/airport-taxis": "Taxis aéroport", "/login": "Connexion", "/signup": "Créer un compte",
      "/forgot-password": "Mot de passe oublié", "/reset-password": "Nouveau mot de passe", "/account": "Mon compte",
      "/bookings": "Mes réservations", "/manage": "Gérer ma réservation", "/support": "Assistance", "/support/cases": "Mes demandes d'assistance",
      "/about": "À propos de Toukky", "/faq": "Aide & questions fréquentes", "/refund-policy": "Politique de remboursement", "/terms": "Conditions générales",
      "/privacy": "Politique de confidentialité", "/cookies": "Préférences de cookies", "/partners": "Partenaires", "/partners/register": "Devenir partenaire", "/partners/register/payouts": "Versements", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "Séjour", flightDetail: "Vol", passengers: "Passagers", carDetail: "Voiture",
    bookingDetail: "Réservation", bookingSuccess: "Suivi de réservation", partnerArea: "Espace partenaire", supportCase: "Demande d'assistance",
  },
  es: {
    home: "Toukky — ¿Adónde quieres ir?",
    exact: {
      "/": "", "/hotels": "Alojamientos", "/flights": "Vuelos", "/flight-hotel": "Vuelo + Hotel", "/cars": "Alquiler de coches",
      "/attractions": "Actividades", "/airport-taxis": "Taxis de aeropuerto", "/login": "Iniciar sesión", "/signup": "Crear una cuenta",
      "/forgot-password": "Contraseña olvidada", "/reset-password": "Nueva contraseña", "/account": "Mi cuenta",
      "/bookings": "Mis reservas", "/manage": "Gestionar reserva", "/support": "Ayuda", "/support/cases": "Mis solicitudes de asistencia",
      "/about": "Sobre Toukky", "/faq": "Ayuda y preguntas frecuentes", "/refund-policy": "Política de reembolso", "/terms": "Términos y condiciones",
      "/privacy": "Política de privacidad", "/cookies": "Preferencias de cookies", "/partners": "Partners", "/partners/register": "Hazte partner", "/partners/register/payouts": "Pagos", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "Alojamiento", flightDetail: "Vuelo", passengers: "Pasajeros", carDetail: "Coche",
    bookingDetail: "Reserva", bookingSuccess: "Estado de la reserva", partnerArea: "Área de partners", supportCase: "Solicitud de asistencia",
  },
  pt: {
    home: "Toukky — Para onde quer ir?",
    exact: {
      "/": "", "/hotels": "Estadias", "/flights": "Voos", "/flight-hotel": "Voo + Hotel", "/cars": "Aluguer de carros",
      "/attractions": "Atividades", "/airport-taxis": "Táxis de aeroporto", "/login": "Iniciar sessão", "/signup": "Criar uma conta",
      "/forgot-password": "Esqueci a palavra-passe", "/reset-password": "Nova palavra-passe", "/account": "A minha conta",
      "/bookings": "As minhas reservas", "/manage": "Gerir reserva", "/support": "Apoio", "/support/cases": "Os meus pedidos de apoio",
      "/about": "Sobre a Toukky", "/faq": "Ajuda e perguntas frequentes", "/refund-policy": "Política de reembolso", "/terms": "Termos e condições",
      "/privacy": "Política de privacidade", "/cookies": "Preferências de cookies", "/partners": "Parceiros", "/partners/register": "Torne-se parceiro", "/partners/register/payouts": "Pagamentos", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "Estadia", flightDetail: "Voo", passengers: "Passageiros", carDetail: "Carro",
    bookingDetail: "Reserva", bookingSuccess: "Estado da reserva", partnerArea: "Área de parceiros", supportCase: "Pedido de apoio",
  },
  ar: {
    home: "Toukky — إلى أين تريد الذهاب؟",
    exact: {
      "/": "", "/hotels": "الإقامات", "/flights": "الرحلات الجوية", "/flight-hotel": "طيران + فندق", "/cars": "تأجير السيارات",
      "/attractions": "الأنشطة", "/airport-taxis": "تاكسي المطار", "/login": "تسجيل الدخول", "/signup": "إنشاء حساب",
      "/forgot-password": "نسيت كلمة المرور", "/reset-password": "كلمة مرور جديدة", "/account": "حسابي",
      "/bookings": "حجوزاتي", "/manage": "إدارة الحجز", "/support": "الدعم", "/support/cases": "طلبات الدعم الخاصة بي",
      "/about": "عن Toukky", "/faq": "المساعدة والأسئلة الشائعة", "/refund-policy": "سياسة الاسترداد", "/terms": "الشروط والأحكام",
      "/privacy": "سياسة الخصوصية", "/cookies": "تفضيلات ملفات تعريف الارتباط", "/partners": "الشركاء", "/partners/register": "كن شريكاً", "/partners/register/payouts": "المدفوعات", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "الإقامة", flightDetail: "الرحلة", passengers: "المسافرون", carDetail: "السيارة",
    bookingDetail: "الحجز", bookingSuccess: "حالة الحجز", partnerArea: "منطقة الشركاء", supportCase: "طلب دعم",
  },
  zh: {
    home: "Toukky — 您想去哪里？",
    exact: {
      "/": "", "/hotels": "住宿", "/flights": "机票", "/flight-hotel": "机票 + 酒店", "/cars": "租车",
      "/attractions": "活动", "/airport-taxis": "机场接送", "/login": "登录", "/signup": "创建账户",
      "/forgot-password": "忘记密码", "/reset-password": "新密码", "/account": "我的账户",
      "/bookings": "我的预订", "/manage": "管理预订", "/support": "帮助", "/support/cases": "我的客服请求",
      "/about": "关于 Toukky", "/faq": "帮助与常见问题", "/refund-policy": "退款政策", "/terms": "条款与条件",
      "/privacy": "隐私政策", "/cookies": "Cookie 偏好设置", "/partners": "合作伙伴", "/partners/register": "成为合作伙伴", "/partners/register/payouts": "收款", "/trip-groupe": "Trip Groupe",
    },
    hotelDetail: "住宿", flightDetail: "航班", passengers: "乘客", carDetail: "车辆",
    bookingDetail: "预订", bookingSuccess: "预订状态", partnerArea: "合作伙伴专区", supportCase: "客服请求",
  },
};

// components/DestinationShowcase.jsx
export const destinationShowcaseL = {
  en: {
    eyebrow: "Destinations",
    title: "Where will your next story begin?",
    sub: "Explore visits, activities and experiences for your trip. Check the itinerary, dates and conditions of each available offer.",
    trust: [
      ["Details before booking", "Review the program, meeting point and participation requirements."],
      ["Secure payment", "Check the amount and currency before confirming payment."],
      ["Cancellation conditions", "The deadline and any fees depend on the offer you select."],
    ],
  },
  fr: {
    eyebrow: "Destinations",
    title: "O\u00f9 commencera votre prochaine histoire ?",
    sub: "Explorez les visites, activités et expériences pour votre voyage. Consultez le programme, les dates et les conditions de chaque offre disponible.",
    trust: [
      ["Les détails avant de réserver", "Vérifiez le programme, le lieu de rendez-vous et les conditions de participation."],
      ["Paiement s\u00e9curis\u00e9", "Contrôlez le montant et la devise avant de confirmer le paiement."],
      ["Conditions d’annulation", "Les délais et les éventuels frais dépendent de l’offre choisie."],
    ],
  },
  es: {
    eyebrow: "Destinos",
    title: "¿Dónde empezará tu próxima historia?",
    sub: "Explore visitas, actividades y experiencias para su viaje. Consulte el programa, las fechas y las condiciones de cada oferta.",
    trust: [
      ["Detalles antes de reservar", "Revise el programa, punto de encuentro y requisitos de participación."],
      ["Pago seguro", "Revise el importe y la moneda antes de confirmar el pago."],
      ["Condiciones de cancelación", "El plazo y los posibles cargos dependen de la oferta elegida."],
    ],
  },
  pt: {
    eyebrow: "Destinos",
    title: "Onde começará a sua próxima história?",
    sub: "Explore visitas, atividades e experiências para a sua viagem. Consulte o programa, as datas e as condições de cada oferta.",
    trust: [
      ["Detalhes antes de reservar", "Verifique o programa, ponto de encontro e requisitos de participação."],
      ["Pagamento seguro", "Verifique o montante e a moeda antes de confirmar o pagamento."],
      ["Condições de cancelamento", "O prazo e os eventuais custos dependem da oferta escolhida."],
    ],
  },
  ar: {
    eyebrow: "وجهات",
    title: "أين ستبدأ قصتك القادمة؟",
    sub: "استكشف الزيارات والأنشطة والتجارب لرحلتك. راجع البرنامج والتواريخ وشروط كل عرض متاح.",
    trust: [
      ["التفاصيل قبل الحجز", "راجع البرنامج ونقطة اللقاء ومتطلبات المشاركة."],
      ["دفع آمن", "تحقق من المبلغ والعملة قبل تأكيد الدفع."],
      ["شروط الإلغاء", "تعتمد المهلة والرسوم المحتملة على العرض المختار."],
    ],
  },
  zh: {
    eyebrow: "目的地",
    title: "您的下一段故事将从哪里开始？",
    sub: "探索适合旅程的参观项目、活动和体验。请查看每项可用服务的行程、日期和条款。",
    trust: [
      ["预订前查看详情", "请核对活动安排、集合地点和参加要求。"],
      ["安全支付", "确认付款前请核对金额和币种。"],
      ["取消条款", "取消期限和相关费用取决于所选服务。"],
    ],
  },
};

// pages/NotFound.jsx
export const notFoundL = {
  en: {
    title: "Page not found",
    body: "There is nothing at", bodyEnd: "It may have moved, or the link that brought you here may be wrong.",
    flights: "Search flights", flightsHint: "Compare routes and fares",
    stays: "Find a place to stay", staysHint: "Hotels, apartments and villas",
    manage: "Manage a booking", manageHint: "With your Toukky reference number",
    home: "Back to the homepage",
  },
  fr: {
    title: "Page introuvable",
    body: "Il n'y a rien à l'adresse", bodyEnd: "Elle a peut-être changé, ou le lien qui vous a amené ici est erroné.",
    flights: "Chercher un vol", flightsHint: "Comparez les trajets et les tarifs",
    stays: "Trouver un logement", staysHint: "Hôtels, appartements et villas",
    manage: "Gérer une réservation", manageHint: "Avec votre numéro de référence Toukky",
    home: "Retour à l'accueil",
  },
  es: {
    title: "Página no encontrada",
    body: "No hay nada en", bodyEnd: "Puede que se haya movido, o que el enlace que te trajo aquí sea incorrecto.",
    flights: "Buscar vuelos", flightsHint: "Compara rutas y tarifas",
    stays: "Encontrar alojamiento", staysHint: "Hoteles, apartamentos y villas",
    manage: "Gestionar una reserva", manageHint: "Con tu número de referencia Toukky",
    home: "Volver a la página de inicio",
  },
  pt: {
    title: "Página não encontrada",
    body: "Não há nada em", bodyEnd: "Pode ter mudado de lugar, ou a ligação que o trouxe até aqui pode estar errada.",
    flights: "Pesquisar voos", flightsHint: "Compare rotas e tarifas",
    stays: "Encontrar alojamento", staysHint: "Hotéis, apartamentos e vilas",
    manage: "Gerir uma reserva", manageHint: "Com o seu número de referência Toukky",
    home: "Voltar à página inicial",
  },
  ar: {
    title: "الصفحة غير موجودة",
    body: "لا يوجد شيء على العنوان", bodyEnd: "ربما تم نقلها، أو أن الرابط الذي أوصلك إلى هنا غير صحيح.",
    flights: "البحث عن رحلات", flightsHint: "قارن بين المسارات والأسعار",
    stays: "ابحث عن مكان إقامة", staysHint: "فنادق وشقق وفلل",
    manage: "إدارة حجز", manageHint: "باستخدام رقم مرجع Toukky الخاص بك",
    home: "العودة إلى الصفحة الرئيسية",
  },
  zh: {
    title: "页面不存在",
    body: "此地址下没有内容：", bodyEnd: "它可能已被移动，或者带您来到这里的链接有误。",
    flights: "搜索航班", flightsHint: "比较航线与票价",
    stays: "寻找住宿", staysHint: "酒店、公寓和别墅",
    manage: "管理预订", manageHint: "使用您的 Toukky 参考编号",
    home: "返回首页",
  },
};

// Settlement refusal copy. Export name retained for compatibility; no purchase deadline.
export const purchaseWindowL = {
  en: {
    lateTitle: "Payment received — booking not confirmed",
    lateSub: "Your payment was received, but the offer was no longer available or the booking had been cancelled. The booking is cancelled and your refund has been requested. Do not pay again." },
  fr: {
    lateTitle: "Paiement reçu — réservation non confirmée",
    lateSub: "Votre paiement a été reçu, mais l'offre n'était plus disponible ou la réservation avait été annulée. Elle est annulée et votre remboursement est demandé. Ne payez pas une seconde fois." },
  es: {
    lateTitle: "Pago recibido — reserva no confirmada",
    lateSub: "Recibimos tu pago, pero la oferta ya no estaba disponible o la reserva había sido cancelada. La reserva está cancelada y se ha solicitado tu reembolso. No pagues otra vez." },
  pt: {
    lateTitle: "Pagamento recebido — reserva não confirmada",
    lateSub: "O seu pagamento foi recebido, mas a oferta já não estava disponível ou a reserva tinha sido cancelada. A reserva está cancelada e o seu reembolso foi pedido. Não pague outra vez." },
  ar: {
    lateTitle: "تم استلام الدفع — الحجز غير مؤكد",
    lateSub: "تم استلام دفعك، لكن العرض لم يعد متاحًا أو كان الحجز قد أُلغي. الحجز ملغى وتم طلب استرداد أموالك. لا تدفع مرة ثانية." },
  zh: {
    lateTitle: "已收到付款——预订未确认",
    lateSub: "已收到您的付款，但所选项目已无法预订，或预订此前已被取消。此预订已取消，我们已为您申请退款。请勿再次付款。" },
};

// A transfer is a request until the driver accepts it (backend
// modules/partners/acceptance): the words for the traveller before that yes,
// and after a no. Read by components/confirmation/status.js.
export const transferAcceptanceL = {
  en: {
    awaitingTitle: "Request sent — waiting for the driver to confirm",
    awaitingSub: "Your payment is received and your request is with the driver. The transfer is confirmed only once the driver accepts it; this page shows the answer. If the driver cannot take it, the booking is cancelled and your refund is requested.",
    declinedTitle: "The driver cannot take this transfer",
    declinedSub: "The booking is cancelled.",
    refundRequested: "Your refund has been requested.",
    refunded: "Your payment has been refunded." },
  fr: {
    awaitingTitle: "Demande envoyée, en attente de confirmation du chauffeur",
    awaitingSub: "Votre paiement est reçu et votre demande est transmise au chauffeur. Le transfert n'est confirmé qu'une fois accepté par le chauffeur ; sa réponse s'affiche sur cette page. S'il ne peut pas l'assurer, la réservation est annulée et votre remboursement est demandé.",
    declinedTitle: "Le chauffeur ne peut pas assurer ce transfert",
    declinedSub: "La réservation est annulée.",
    refundRequested: "Votre remboursement est demandé.",
    refunded: "Votre paiement a été remboursé." },
  es: {
    awaitingTitle: "Solicitud enviada: pendiente de confirmación del conductor",
    awaitingSub: "Hemos recibido tu pago y tu solicitud está con el conductor. El traslado solo queda confirmado cuando el conductor lo acepta; esta página muestra su respuesta. Si no puede hacerlo, la reserva se cancela y se solicita tu reembolso.",
    declinedTitle: "El conductor no puede realizar este traslado",
    declinedSub: "La reserva está cancelada.",
    refundRequested: "Se ha solicitado tu reembolso.",
    refunded: "Tu pago ha sido reembolsado." },
  pt: {
    awaitingTitle: "Pedido enviado — a aguardar a confirmação do motorista",
    awaitingSub: "Recebemos o seu pagamento e o seu pedido foi enviado ao motorista. O transfer só fica confirmado quando o motorista o aceitar; esta página mostra a resposta. Se não o puder fazer, a reserva é cancelada e o seu reembolso é pedido.",
    declinedTitle: "O motorista não pode fazer este transfer",
    declinedSub: "A reserva está cancelada.",
    refundRequested: "O seu reembolso foi pedido.",
    refunded: "O seu pagamento foi reembolsado." },
  ar: {
    awaitingTitle: "تم إرسال الطلب — في انتظار تأكيد السائق",
    awaitingSub: "تم استلام دفعك وأُرسل طلبك إلى السائق. لا يُؤكَّد النقل إلا بعد أن يقبله السائق، وتظهر إجابته في هذه الصفحة. إذا تعذّر عليه ذلك، يُلغى الحجز ويُطلب استرداد أموالك.",
    declinedTitle: "لا يستطيع السائق القيام بهذا النقل",
    declinedSub: "تم إلغاء الحجز.",
    refundRequested: "تم طلب استرداد أموالك.",
    refunded: "تم استرداد المبلغ الذي دفعته." },
  zh: {
    awaitingTitle: "请求已发送，等待司机确认",
    awaitingSub: "已收到您的付款，您的请求已发送给司机。司机接受后，接送才算确认，司机的答复会显示在此页面。如果司机无法接单，预订将被取消，并为您申请退款。",
    declinedTitle: "司机无法提供此次接送",
    declinedSub: "此预订已取消。",
    refundRequested: "已为您申请退款。",
    refunded: "您的付款已退还。" },
};

// Wolof: the presentation texts only, every other word French (i18n/wolof.js).
pageTitlesL.wo = withWolof(pageTitlesL.fr, WOLOF.pageTitles, "pageTitles");
